var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"landing"}},[_c('div',{staticClass:"splash"},[_c('div',{staticClass:"splash-logo"},[_c('img',{staticClass:"text-logo",attrs:{"src":require("../../assets/mobkast-logo-text.png")}})])])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6b3b9ac","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/site/Landing.vue
// module id = 5Hwl
// module chunks = 0